<template>
  <v-container fluid>
    <v-row class="common-card-row">
      <v-col>
        <div class="d-flex py-3">
          <div>
            <img
              :src="$auth.user.picture"
              alt="User's profile picture"
              class="rounded-circle img-fluid profile-picture"
            />
          </div>
          <div class="px-5 text-center text-md-left align-self-center">
            <h2>{{ $auth.user.name }}</h2>
            <p class="lead text-muted">{{ $auth.user.email }}</p>
          </div>
          <div class="ml-auto">
            <v-btn dark color="vtblue" outlined @click="logout()">
              {{ $t("common.labels.logout") }}
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="common-card-row">
      <v-col class="common-card-col">
        <v-card class="profile-card">
          <v-card-title>{{ $t("views.Profile.userInformation.title") }}</v-card-title>
          <v-card-text class="text-subtitle-1">
            <v-row>
              <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{ $t("common.labels.name") }}</v-col>
              <v-col cols="6" sm="10">{{ $auth.user.name }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{ $t("common.labels.email") }}</v-col>
              <v-col cols="6" sm="10">{{ $auth.user.email }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{ $t("common.labels.nickname") }}</v-col>
              <v-col cols="6" sm="10">{{ $auth.user.nickname }}</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="common-card-row pb-3">
      <v-col class="common-card-col">
        <v-card class="profile-card">
          <v-card-title>{{ $t("views.Profile.managePreferences.title") }}</v-card-title>
          <v-card-text class="text-subtitle-1">
            <v-row v-if="$store.state.showLanguage">
              <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{
                $t("views.Profile.preferences.language")
              }}</v-col>
              <v-col cols="6" sm="3">
                <LanguageSelect :colLenght="6" />
              </v-col>
            </v-row>
            <v-row class="mt-0">
              <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{ $t("views.Profile.preferences.theme") }}</v-col>
              <v-col cols="6" sm="3">
                <ThemeVT />
              </v-col>
            </v-row>
            <v-form ref="form" v-model="valid_settings">
              <v-row>
                <v-col cols="6" sm="2" class="pr-5 font-weight-bold">{{
                  $t("views.Profile.managePreferences.defaultTab")
                }}</v-col>
                <v-col cols="6" sm="3">
                  <v-select
                    v-if="user_config && sections"
                    dense
                    color="primaryDark"
                    :items="sections"
                    item-text="label"
                    v-model="user_config.default_section"
                    item-value="id"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="2" class="pr-5 font-weight-bold"
                  >{{ $t("views.Profile.managePreferences.manageSections")
                  }}<TooltipVT text="Enable/Disable sections"></TooltipVT
                ></v-col>
                <v-col cols="6" sm="3">
                  <div class="d-flex" v-for="(section, indx) in all_sections" :key="`${section.id}_${indx}`">
                    <v-switch
                      dense
                      :label="section.label"
                      :value="section.isVisible"
                      hide-details
                      v-model="section.isVisible"
                      @change="update_tabs($event, section)"
                    ></v-switch>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="2" class="pr-5 font-weight-bold"
                  >{{ $t("views.Profile.managePreferences.arrangeSections")
                  }}<TooltipVT text="Drag and Drop"></TooltipVT
                ></v-col>
                <v-col cols="6" sm="3">
                  <SelectVT :items="sections" item_text="label" @item_updated="update_sections($event)"></SelectVT
                ></v-col>
              </v-row>
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="auto">
                  <v-btn dense outlined class="mr-2 bold">{{ $t("common.words.reset") }}</v-btn>
                  <v-btn dense color="primary" @click="update_user_config" class="bold" :disabled="!valid_settings">{{
                    $t("common.words.save")
                  }}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import LanguageSelect from "../components/LanguageSelect.vue";
import ThemeVT from "../components/ThemeVT.vue";
import SelectVT from "../components/SelectVT";
import TooltipVT from "../components/TooltipVT";
import { axios_post } from "../services/vt_service";
import { user } from "../services/common";
import { first_letter_uppercase } from "../helpers/helpers";
import { content } from "../../config/config.js";

export default {
  name: "Profile",
  components: {
    SelectVT,
    TooltipVT,
    LanguageSelect,
    ThemeVT,
  },
  data: () => ({
    sections: null,
    valid_settings: false,
    user_config: null,
    all_sections: null,
    selected_tabs: null,
    alerts_enabled: true,
    page_content: null,
    events_enabled: true, //Pop up event notifications
    events_email_enabled: true, //email alerts for events
  }),
  mounted() {
    // this.$nextTick(() => {
    //   this.get_sections();
    // });
    this.page_content = content;
    this.$store.commit("update_page_title", "Profile");
    window.setTimeout(() => {
      this.get_sections();
      this.get_user_config();
    }, 2000);
  },
  methods: {
    logout() {
      localStorage.clear();
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
    update_tabs(ev, section) {
      if (ev) {
        this.sections.push(section);
      } else {
        this.sections = this.sections.filter((elem) => {
          return elem.id != section.id;
        });
      }
    },
    update_sections(ev) {
      let removed = this.user_config.sections_order.splice(ev[0], 1);
      this.user_config.sections_order.splice(ev[1], 0, removed[0]);
      removed = this.sections.splice(ev[0], 1);
      this.sections.splice(ev[1], 0, removed[0]);
    },
    get_user_config() {
      this.selected_tabs = [];
      let saved_user_config = JSON.parse(JSON.stringify(this.$store.state.user_config));
      let default_user_config = {
        user_id: this.$auth.user.sub,
        default_section: saved_user_config.default_section || this.sections[0].id,
        sections_order:
          saved_user_config.sections_order ||
          this.sections.map((elem) => {
            return elem.id;
          }),
        asset_tabs:
          saved_user_config.asset_tabs ||
          this.selected_tabs.map((elem) => {
            return elem.id;
          }),
      };
      this.user_config = { ...default_user_config, ...saved_user_config };
      this.sections = [];
      this.$store.state.sections &&
        this.user_config["sections_order"] &&
        this.user_config["sections_order"].map((elem) => {
          let index = this.$store.state.sections[2].indexOf(elem);
          if (index != -1)
            this.sections.push({
              ...this.$config.tabs[elem],
              label: this.$store.state.sections[1][index],
            });
        });
      let temp = [];
      this.$store.state.sections &&
        this.$store.state.sections[2].forEach((tab_id) => {
          let index = this.$store.state.sections[2].indexOf(tab_id);
          if (index != -1) {
            let ob = JSON.parse(JSON.stringify(this.$config.tabs[tab_id]));
            ob["isVisible"] =
              (this.$store.state.user_config && !("sections_order" in this.$store.state.user_config)) ||
              (this.$store.state.user_config.sections_order &&
                this.$store.state.user_config.sections_order.indexOf(tab_id) != -1);
            temp.push({ ...ob, label: this.$store.state.sections[1][index] });
          }
        });
      this.all_sections = temp;
      let tabs = {};
      this.$config.powerdata.tabs.forEach((elem) => {
        tabs[elem.id] = elem;
      });
    },
    async update_user_config() {
      let config = JSON.parse(JSON.stringify(this.user_config));
      config.sections_order = this.sections.map((elem) => {
        return elem.id;
      });
      config.asset_tabs = JSON.parse(JSON.stringify(this.selected_tabs));
      config.alerts_enabled = this.alerts_enabled;
      config.events_enabled = this.events_enabled; //Pop up event notifications
      config.events_email_enabled = this.events_email_enabled; //Email event notifications
      if (this.$refs.form.validate()) {
        await axios_post(user.update_user_config, config);
        this.$store.dispatch("update_message", {
          msg: "Settings updated successfully!",
        });
        this.$store.dispatch("show_message");
        this.$store.commit("update_config", config);
      }
      if (this.selectedLanguage) {
        this.$store.commit("set_language", this.selectedLanguage.value);
        localStorage.setItem("language", this.selectedLanguage.value);
      }
      location.reload();
    },
    get_sections: function () {
      this.sections = [];
      let temp = [];
      this.$store.state.sections &&
        this.$store.state.sections[2].forEach((tab_id) => {
          let index = this.$store.state.sections[2].indexOf(tab_id);
          if (index != -1) {
            temp.push({
              ...this.$config.tabs[tab_id],
              label: this.$store.state.sections[1][index],
            });
          }
        });
      this.sections = temp;
    },
  },
  computed: {},
};
</script>

<style scoped>
.profile-card {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>
